import { usePropertyTransisions } from './hooks'

export default () => {
    usePropertyTransisions()
    return null
}
